<div class="popup-content">
    <h6 [ngStyle]="{'color': processColor}"
        style="font-size: clamp(0.75em, 16px, 2em); font-weight: 500; margin-bottom: 4%;">
        {{ stage.localName }}
    </h6>
    <div class="acelen-product-name-container">
        <span class="acelen-product-name" style="color:#000; font-weight: 600; font-size: 10px;">
            Produto final: {{ stage.name }}
        </span>
    </div>
    <div class="acelen-product-info">
        <span style="font-size: 10px; font-weight: 500;" [ngStyle]="{'color': processColor}">
            <b style="color:#000; font-weight: 500;"> Processo: </b> {{ stage.processName || '-' }}
        </span>
        <span style="font-size: 10px; font-weight: 500;" [ngStyle]="{'color': processColor}">
            <b style="color:#000; font-weight: 500;"> Blockchain Token: </b> {{ stage.blockchainToken || '-' }}
        </span>
        <span style="font-size: 10px; font-weight: 500;" [ngStyle]="{'color': processColor}">
            <b style="color:#000; font-weight: 500;"> Quantidade: </b> {{ stage.amount || '-' }}
        </span>
        <span style="font-size: 10px; font-weight: 500;" [ngStyle]="{'color': processColor}">
            <b style="color:#000; font-weight: 500;"> Unidade de Medida: </b> {{ stage.meansurementType || '-' }}
        </span>
        <span style="font-size: 10px; font-weight: 500;" [ngStyle]="{'color': processColor}">
            <b style="color:#000; font-weight: 500;"> Lote: </b> {{ stage.batch || '-' }}
        </span>
    </div>

    @if(isExpanded === true) {
        <div class="acelen-product-name-container">
            <span class="acelen-product-name" style="color:#000; font-weight: 600; font-size: 10px;">
                Listagem de Insumos
            </span>
        </div>
        <div class="acelen-product-info">
            @for(input of stage.inputs; track $index) {
                <span style="font-size: 10px; font-weight: 500;" [ngStyle]="{'color': processColor}">
                    <b style="color:#000; font-weight: 500;"> Nome: </b> {{ input.name || '-' }}
                </span>
                <span style="font-size: 10px; font-weight: 500;" [ngStyle]="{'color': processColor}">
                    <b style="color:#000; font-weight: 500;"> Blockchain Token: </b> {{ input.blockchainToken || '-' }}
                </span>
            }
        </div>
    }

    <button class="more" (click)="rotateAndExpand()" [class.rotateUp]="rotateButton" [class.rotateDown]="!rotateButton">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
            [attr.fill]="processColor">
            <path
                d="M480-200 240-440l56-56 184 183 184-183 56 56-240 240Zm0-240L240-680l56-56 184 183 184-183 56 56-240 240Z" />
        </svg>
    </button>
</div>